import Vue from 'vue'
import { FORM_ADD_PARAMS, FORM_FIELD_TYPE } from '@shared/const/form/form.field'
import { isEmpty } from '@shared/utils/type'
import { nameEntityToEntityEmailIdMap } from '@shared/const/form/form.data'

const EMAIL_CHECK_ERROR_TEXT = 'Не удалось проверить e-mail'

export async function formValidate(field, form) {
  field.error = false
  field.valid = false
  field.errorText = null

  return await runFieldValidators(field, form)
}

async function runFieldValidators(field, form) {
  const validators = getFieldValidators(field)

  for (const validator of validators) {
    const result = await validator(field, form)

    if (!result.valid) {
      return result
    }
  }

  return setValid(field)
}

function getFieldValidators(field) {
  const validators = [runBaseFieldValidator]

  if (hasBlockedValuesRule(field)) {
    validators.push(runBlockedValuesValidator)
  }

  if (hasEmailCheckRule(field)) {
    validators.push(runHasEmailValidator)
  }

  if (hasCheckEmailRule(field)) {
    validators.push(runCheckEmailValidator)
  }

  return validators
}

function runBaseFieldValidator(field) {
  const value = field.value
  const pattern = field.pattern
  const errorText = field.patternErrorText

  if (field.typeField === FORM_FIELD_TYPE.VIEW_HIDDEN || field.typeField === FORM_FIELD_TYPE.STUB_TEXT) {
    return setValid(field)
  }

  if (field.requiredField) {
    if (field.typeField === FORM_FIELD_TYPE.PHONE && field.value?.includes('_')) {
      return setInvalid(field, 'Обязательное поле')
    } else if (Array.isArray(value) && value.length === 0) {
      return setInvalid(field, 'Обязательное поле')
    } else if (!Array.isArray(value) && isEmpty(value)) {
      return setInvalid(field, 'Обязательное поле')
    } else if (isEmpty(value) || value === false) {
      return setInvalid(field, 'Обязательное поле')
    } else if (pattern && !pattern.test(value)) {
      return setInvalid(field, errorText)
    }
  } else if (!isEmpty(value) && pattern && !pattern.test(value)) {
    return setInvalid(field, errorText)
  }

  return setValid(field)
}

function hasBlockedValuesRule(field) {
  return field?.addParams?.[FORM_ADD_PARAMS.blockedValues]
}

function runBlockedValuesValidator(field) {
  const rule = field.addParams[FORM_ADD_PARAMS.blockedValues]

  if (!rule?.values) {
    return setValid(field)
  }

  const matchedItem = rule.values.find(value => {
    const fieldValue = rule?.subField ? field.value?.[rule.subField] : field.value
    return String(fieldValue ?? '').trim() === value
  })

  if (!matchedItem) {
    return setValid(field)
  }

  return setInvalid(field, rule.message)
}

function hasEmailCheckRule(field) {
  return field?.addParams?.[FORM_ADD_PARAMS.hasEmail] && !isEmpty(field.value)
}

async function runHasEmailValidator(field, form) {
  try {
    const baseUrl = field.addParams[FORM_ADD_PARAMS.hasEmail]
    const url = getHasEmailUrl(baseUrl, form)

    if (!url) {
      return setInvalid(field, EMAIL_CHECK_ERROR_TEXT)
    }

    const response = await Vue.http.post(url, { email: field.value })

    return response?.body?.success ? setValid(field) : setInvalid(field, response?.body?.error ?? '')
  } catch (err) {
    console.error(err)

    return setInvalid(field, EMAIL_CHECK_ERROR_TEXT)
  }
}

function getHasEmailUrl(baseUrl, form) {
  if (!form.entityId || !form.nameEntity) {
    return ''
  }

  const params = new URLSearchParams()

  params.append('entity[]', String(nameEntityToEntityEmailIdMap(form.nameEntity)))
  params.append('id', String(form.entityId))

  return `${baseUrl}?${params.toString()}`
}

function hasCheckEmailRule(field) {
  return field?.addParams?.[FORM_ADD_PARAMS.checkEmail] && !isEmpty(field.value)
}

async function runCheckEmailValidator(field) {
  try {
    const baseUrl = field.addParams[FORM_ADD_PARAMS.checkEmail]

    if (!baseUrl) {
      return setInvalid(field, EMAIL_CHECK_ERROR_TEXT)
    }

    const response = await Vue.http.post(baseUrl, { email: field.value })

    return response?.body?.success ? setValid(field) : setInvalid(field, response?.body?.error ?? '')
  } catch (err) {
    console.error(err)

    return setInvalid(field, EMAIL_CHECK_ERROR_TEXT)
  }
}

function setInvalid(field, message) {
  field.error = true
  field.valid = false
  field.errorText = message

  return {
    valid: false,
    message,
  }
}

function setValid(field) {
  field.error = false
  field.valid = true
  field.errorText = null

  return {
    valid: true,
    message: null,
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/form/form.validate.js